import { render, staticRenderFns } from "./degreeApplyResult.vue?vue&type=template&id=32da8c98&scoped=true"
import script from "./degreeApplyResult.vue?vue&type=script&lang=js"
export * from "./degreeApplyResult.vue?vue&type=script&lang=js"
import style0 from "./degreeApplyResult.vue?vue&type=style&index=0&id=32da8c98&prod&scoped=true&lang=scss"
import style1 from "./degreeApplyResult.vue?vue&type=style&index=1&id=32da8c98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32da8c98",
  null
  
)

export default component.exports